import { Input } from "@/components/ui/input";
import { UserProfile } from "@/types/user";

interface PersonalInfoProps {
  profile: UserProfile;
  isEditing: boolean;
  onUpdate: (field: string, value: string) => void;
}

export function PersonalInfo({ profile, isEditing, onUpdate }: PersonalInfoProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold">Informações Pessoais</h2>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-gray-700">Nome</label>
          {isEditing ? (
            <Input
              value={profile.name}
              onChange={(e) => onUpdate('name', e.target.value)}
              placeholder="Seu nome completo"
            />
          ) : (
            <p className="mt-1 text-gray-900">{profile.name || 'Não informado'}</p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">Email</label>
          {isEditing ? (
            <Input
              value={profile.email}
              onChange={(e) => onUpdate('email', e.target.value)}
              type="email"
              placeholder="seu@email.com"
            />
          ) : (
            <p className="mt-1 text-gray-900">{profile.email}</p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">Telefone</label>
          {isEditing ? (
            <Input
              value={profile.phone}
              onChange={(e) => onUpdate('phone', e.target.value)}
              placeholder="(00) 00000-0000"
            />
          ) : (
            <p className="mt-1 text-gray-900">{profile.phone || 'Não informado'}</p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">Cidade</label>
          {isEditing ? (
            <Input
              value={profile.city}
              onChange={(e) => onUpdate('city', e.target.value)}
              placeholder="Sua cidade"
            />
          ) : (
            <p className="mt-1 text-gray-900">{profile.city || 'Não informado'}</p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700">Endereço</label>
          {isEditing ? (
            <Input
              value={profile.address}
              onChange={(e) => onUpdate('address', e.target.value)}
              placeholder="Seu endereço completo"
            />
          ) : (
            <p className="mt-1 text-gray-900">{profile.address || 'Não informado'}</p>
          )}
        </div>
      </div>
    </div>
  );
}